import { ResourcesConfig } from 'aws-amplify';
import { CANONICAL_PRODUCTION_OAUTH_ORIGIN } from './app/oauth-origin';

// Canonical apex origin used for production OAuth redirects. Hardcoded so the
// `redirect_uri` Cognito sees is stable regardless of which subdomain
// (apex vs `www.`) the user happened to land on. Mismatched redirect_uri
// caused Safari mobile to show "An error was encountered with the requested
// page" (Cognito's `redirect_mismatch`).
const PRODUCTION_OAUTH_ORIGIN = CANONICAL_PRODUCTION_OAUTH_ORIGIN;

function resolveOAuthOrigin(): string {
  if (typeof window === 'undefined') {
    return 'http://localhost:5173';
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return window.location.origin;
  }
  return PRODUCTION_OAUTH_ORIGIN;
}

const oauthOrigin = resolveOAuthOrigin();
const env = import.meta.env;
export const googleOAuthEnabled = env.VITE_ENABLE_GOOGLE_OAUTH === 'true';

// CDK deployment values (dev environment)
const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_rijL46Prd',
      userPoolClientId: '4nk8qajt3itc3sevqnb6nnou7h',
      identityPoolId: 'us-east-1:b5a920fe-d83a-4c43-9ac4-921275dc00d9',
      loginWith: {
        oauth: {
          domain: 'trackwithai-dev.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [`${oauthOrigin}/login`],
          redirectSignOut: [`${oauthOrigin}/`],
          responseType: 'code',
          ...(googleOAuthEnabled ? { providers: ['Google' as const] } : {}),
        },
      },
    },
  },
};

// API configuration
export const apiConfig = {
  restApiUrl: env.VITE_REST_API_URL || 'https://s8xxq6ygn6.execute-api.us-east-1.amazonaws.com/dev/',
  chatSSEUrl: env.VITE_CHAT_SSE_URL || 'https://ews5gje5n2o6erf2duf7ai6vze0gdvnj.lambda-url.us-east-1.on.aws/',
  // Standalone Function URL for the third-party MCP gateway. Keep this separate from
  // the REST API: MCP uses bearer PATs/OAuth and is intentionally independently deployed.
  mcpServerUrl: env.VITE_MCP_SERVER_URL || 'https://ziaadlsxhik6keoeqeb5milsea0fdcev.lambda-url.us-east-1.on.aws/',
  // trackwith.ai is an alias on the same CloudFront distribution (owner ruling 2026-07-04).
  publicStartSSEUrl: env.VITE_PUBLIC_START_SSE_URL || 'https://trackwith.ai/public-start-sse',
  // DM (MP 5.11) + admin coach-application (MP 5.8) + authenticated /api/scheduling/** routes
  // (dual-homed off the Dashboard RestApi for 500-resource headroom, twa-flr) live on their own
  // API Gateway — see infra/lib/stacks/coach-api-stack.ts. Same Cognito auth; different base URL.
  coachApiUrl: env.VITE_COACH_API_URL || 'https://m2559rsskb.execute-api.us-east-1.amazonaws.com/dev/',
};

export const amplifyConfig = config;
